module.exports = __webpack_public_path__ + "img/pw-logo-white.ba76546e.svg";